
function gsmYes() {
    var gsm = form.querySelector('.sf-field-post-meta-idoil_integrated_gsm_modem input[value="true"]');
    gsm.click();
}


function beaconYes() { 
    beaconEnable();
    var beacon = form.querySelector('.sf-field-post-meta-idoil_beacon input[value="true"]');
    beacon.click();
}
function beaconNo() {
    beaconEnable();
    var beacon = form.querySelector('.sf-field-post-meta-idoil_beacon input[value="false"]');
    beacon.click();
}



function gsmDisable() {
    var allgsm = form.querySelectorAll('.sf-field-post-meta-idoil_integrated_gsm_modem input');
    var i;
    for (i = 0; i < allgsm.length; i++) {
        allgsm[i].disabled = true;
    }
}

function gsmEnable() {
    var allgsm = form.querySelectorAll('.sf-field-post-meta-idoil_integrated_gsm_modem input');
    var i;
    for (i = 0; i < allgsm.length; i++) {
        allgsm[i].disabled = false;
    }
}

function beaconDisable() {
    var allbeacon = form.querySelectorAll('.sf-field-post-meta-idoil_beacon input');
    var i;
    for (i = 0; i < allbeacon.length; i++) {
        allbeacon[i].disabled = true;
    }
}
function beaconEnable() {
    var allbeacon = form.querySelectorAll('.sf-field-post-meta-idoil_beacon input');
    var i;
    for (i = 0; i < allbeacon.length; i++) {
        allbeacon[i].disabled = false;
    }
}

function checkAll() {
    var returnedObject = {};
    returnedObject.power = form.querySelector('.sf-field-post-meta-idoil_power .sf-option-active input').value;
    returnedObject.gsm = form.querySelector('.sf-field-post-meta-idoil_integrated_gsm_modem .sf-option-active input').value;
    returnedObject.beacon = form.querySelector('.sf-field-post-meta-idoil_beacon .sf-option-active input').value;
    return returnedObject;
}



function resetGsmAndBeacon() {
    var firstgsm = form.querySelector('.sf-field-post-meta-idoil_integrated_gsm_modem .sf-item-0 input');
    var firstbeacon = form.querySelector('.sf-field-post-meta-idoil_beacon .sf-item-0 input');

    gsmEnable();
    firstgsm.click();
    beaconEnable();
    firstbeacon.click();

}


function checkSensors(oilactive, highactive, sludgeactive) {
    var returnedObject = {};

    if (oilactive === '') {
        var oilactive = parseInt(form.querySelector('.sf-field-post-meta-idoil_oil_sensors .sf-option-active input').value);
    }
    if (highactive === '') {
        var highactive = parseInt(form.querySelector('.sf-field-post-meta-idoil_high_level_sensors .sf-option-active input').value);
    }
    if (sludgeactive === '') {
        var sludgeactive = parseInt(form.querySelector('.sf-field-post-meta-idoil_sludge_sensors .sf-option-active input').value);
    }

    returnedObject.oil = oilactive;
    returnedObject.high = highactive;
    returnedObject.sludge = sludgeactive;
    returnedObject.total = returnedObject.oil + returnedObject.high + returnedObject.sludge;
    return returnedObject;

}

function disableSearch(totalSensors) {
    var messagebox = document.getElementById('searchmessage');
    var submitbutton = form.querySelector('.sf-field-submit input');
    var oilhead = form.querySelector('.sf-field-post-meta-idoil_oil_sensors h4');
    var highhead = form.querySelector('.sf-field-post-meta-idoil_high_level_sensors h4');
    var sludgehead = form.querySelector('.sf-field-post-meta-idoil_sludge_sensors h4');
    if (totalSensors > 3) {
        messagebox.innerHTML = '<p>' + messagebox.getAttribute('data-max-sensors') + '</p>';
        submitbutton.disabled = true;
        oilhead.style.color = 'red';
        highhead.style.color = 'red';
        sludgehead.style.color = 'red';
    } else if (totalSensors === 0) {
        messagebox.innerHTML = '<p>' + messagebox.getAttribute('data-min-sensors') + '</p>';
        submitbutton.disabled = true;
        oilhead.style.color = 'red';
        highhead.style.color = 'red';
        sludgehead.style.color = 'red';
    } else {
        messagebox.innerHTML = '';
        submitbutton.disabled = false;
        oilhead.style.color = '';
        highhead.style.color = '';
        sludgehead.style.color = '';
    }

}


function disableRelays() {
    var allrelays = form.querySelectorAll('.sf-field-post-meta-idoil_relays input');
    var twopcsconf = form.querySelector('.sf-field-post-meta-idoil_relays input[value="2-pcs-customer-configurable"]');
    
    var i;
    for (i = 0; i < allrelays.length; i++) {
        allrelays[i].disabled = true;
    }
    twopcsconf.disabled = false;
    twopcsconf.click();
}

function enableRelays() {
    var allrelays = form.querySelectorAll('.sf-field-post-meta-idoil_relays input');
    var i;
    for (i = 0; i < allrelays.length; i++) {
        allrelays[i].disabled = false;
    }
}

function moveGsmText() {
    var gsmtext = document.querySelector('#gsm-text').innerHTML;
    var newgsmtext = '<p class="gsmtextafter">'+gsmtext+'</p>';
    var gsmhead = form.querySelector('.sf-field-post-meta-idoil_integrated_gsm_modem h4');

    jQuery(newgsmtext).insertAfter(gsmhead);
}

function checkCustom() { //HIDE PACKAGE NAME OR CONTROL UNIT
    var tuotteet = document.getElementById('tuotteet');

    if (tuotteet) {
        var allpackage = tuotteet.querySelectorAll('.packagename');
        var allcontrol = tuotteet.querySelectorAll('.controlunit');
        var firsttuote = tuotteet.querySelector('tbody tr:first-child td:first-child');
        var i;
        if (firsttuote.innerHTML == 'Custom') {
            for (i = 0; i < allpackage.length; i++) {
                //allpackage[i].classList.add('hiddenfield');
                allpackage[i].style.display = 'none';
            }
        } else {
            for (i = 0; i < allcontrol.length; i++) {
                //allcontrol[i].classList.add('hiddenfield');
                allcontrol[i].style.display = 'none';
            }
        }
    }

} 


var form = document.getElementById('search-filter-form-13378');

if (form) {

var alloil = form.querySelectorAll('.sf-field-post-meta-idoil_oil_sensors input[name="_sfm_idoil_oil_sensors[]"]');
var allhigh = form.querySelectorAll('.sf-field-post-meta-idoil_high_level_sensors input[name="_sfm_idoil_high_level_sensors[]"]');
var allsludge = form.querySelectorAll('.sf-field-post-meta-idoil_sludge_sensors input[name="_sfm_idoil_sludge_sensors[]"]');

var allpower = form.querySelectorAll('.sf-field-post-meta-idoil_power input[name="_sfm_idoil_power[]"]');
var allgsm = form.querySelectorAll('.sf-field-post-meta-idoil_integrated_gsm_modem input[name="_sfm_idoil_integrated_gsm_modem[]"]');
var allbeacon = form.querySelectorAll('.sf-field-post-meta-idoil_beacon input[name="_sfm_idoil_beacon[]"]');


jQuery('document').ready(function(){

    moveGsmText();
    var totalSensors = checkSensors('', '', '');
    disableSearch(totalSensors.total);

    checkAll();
    var selectedPower = checkAll().power;
    if (selectedPower === 'solar') {
        beaconEnable();
    } else if (selectedPower === '') {
    } else {
        beaconNo();
        beaconDisable();
    }
    
    if (totalSensors.oil > 1 || totalSensors.high > 1 || totalSensors.sludge > 1) {
        disableRelays();
    } else {
        enableRelays();
    }

    checkCustom();
    
});

for (let l = 0; l < alloil.length; l++) {
    alloil[l].addEventListener('change', function() {

        var totalSensors = checkSensors(parseInt(this.value), '', '');
        disableSearch(totalSensors.total);
    
        if (totalSensors.oil > 1 || totalSensors.high > 1 || totalSensors.sludge > 1) {
            disableRelays();
        } else {
            enableRelays();
        }

    });
}
for (let m = 0; m < allhigh.length; m++) {
    allhigh[m].addEventListener('change', function() {

        var totalSensors = checkSensors('', parseInt(this.value), '');
        disableSearch(totalSensors.total);

        if (totalSensors.oil > 1 || totalSensors.high > 1 || totalSensors.sludge > 1) {
            disableRelays();
        } else {
            enableRelays();
        }

    });
}
for (let n = 0; n < allsludge.length; n++) {
    allsludge[n].addEventListener('change', function() {

        var totalSensors = checkSensors('', '', parseInt(this.value));
        disableSearch(totalSensors.total);

        if (totalSensors.oil > 1 || totalSensors.high > 1 || totalSensors.sludge > 1) {
            disableRelays();
        } else {
            enableRelays();
        }

    });
}



for (let i = 0; i < allpower.length; i++) {
    allpower[i].addEventListener('change', function() {
        if (this.value === 'solar') {
            beaconEnable();
            resetGsmAndBeacon();
        } else if (this.value === '') {
            resetGsmAndBeacon();
        } else {
            resetGsmAndBeacon();
            beaconNo();
            beaconDisable();
        }
    });
}

for (let j = 0; j < allgsm.length; j++) {
    allgsm[j].addEventListener('change', function() {
        var returnValue = checkAll();
    
        if (returnValue.power === 'solar') {
            if (this.value === 'false') {
                beaconYes();
            } else {
            }
        }

    });
}

for (let k = 0; k < allbeacon.length; k++) {
    allbeacon[k].addEventListener('change', function() {
        var returnValue = checkAll();
        if (returnValue.power === 'solar') {
            if (this.value === 'false') {
                gsmYes();
            } else {
            }
        }
        
    });
}

}